"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnToast = exports.getDefaultDelay = exports.errorToast = exports.buildToast = void 0;
var _auth = require("../utils/auth");
var _toasts = _interopRequireDefault(require("../constants/toasts"));
var _constants = require("../../components/Toast/constants");
const isValidCategory = category => Object.keys(_toasts.default).includes(category);
const getProperCategory = category => isValidCategory(category.toLowerCase()) ? category : _toasts.default.info;
const getDefaultDelay = delay => delay === 0 ? delay : delay || 3000;
exports.getDefaultDelay = getDefaultDelay;
const buildToast = options => ({
  id: options.id || (0, _auth.randomString)(16),
  delay: getDefaultDelay(options.delay),
  actions: options.actions || _constants.defaultToastActions,
  category: getProperCategory(options.category),
  text: options.text || ''
});
exports.buildToast = buildToast;
const errorToast = errText => buildToast({
  text: errText,
  category: 'error'
});
exports.errorToast = errorToast;
const warnToast = warnText => buildToast({
  text: warnText,
  category: 'warn'
});
exports.warnToast = warnToast;